import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

// Busca um compromisso pessoal individual em /personal-events/{id}.
export function usePersonalEvent() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const fetchPersonalEvent = useCallback(
    (personalEventId) => {
      setLoading(true);
      return quarkusApi
        .get(`/personal-events/${personalEventId}`, {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .catch((returnFromApi) => {
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.status === 401) {
            navigate('/expired-session');
          }
          throw returnFromApi;
        })
        .finally(() => setLoading(false));
    },
    [navigate],
  );

  return { fetchPersonalEvent, isLoading };
}
